import { apiV2 } from "../../api/axiosConfig";
import { Client } from "../../types/userManagement";
import { useQuery } from "react-query";

export const fetchClient = async (id: string) => {
  const res = await apiV2.get<Client>(`/clients/${id}`);
  return res.data;
};

export const useLoadClient = (id: string | null) =>
  useQuery(["client", id], () => fetchClient(id || ""), {
    enabled: !!id,
    initialData: null,
    placeholderData: null,
  });